// pages/LoginPage.jsx
import React, { Component } from "react";
import { Button, InputGroup, Card } from "@blueprintjs/core";
import {
    BASE_API,
    LOGIN_REDIRECT,
    SUPERADMIN_ORG_SLUG,
    SUBMENU, //  pentru primul tab din admin / echipa
} from "../utils/constants";

class LoginPage extends Component {
    state = { email: "nastasiecosmin@yahoo.com", password: "fotbalmanager", error: null, success: false };

    handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

    /* ─────────────────────────────  LOGIN  ───────────────────────────── */
    handleLogin = async () => {
        const { email, password } = this.state;

        try {
            /* 0️⃣  Request */
            const res = await fetch(`${BASE_API}/api/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password })
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.error || "Eroare necunoscută");

            /* 1️⃣  Login reușit? */
            if (!data.success) {
                if (data?.text) this.setState({ error: data.text });
                return;
            }

            /* 2️⃣  Persistăm sesiunea – fără currentTeam */
            const teams = data.teams ?? [];
            localStorage.setItem(
                "session",
                JSON.stringify({
                    user: data.user,
                    teams: teams,
                    organization: data.organization,
                    loginAt: Date.now()
                })
            );
            this.setState({ success: true, error: null });

            /* 3️⃣  Construim URL-ul de redirect */
            const userRole = data.user.user_role;
            const orgSlug = data.organization.organization_slug;
            let next = "/";

            switch (userRole) {
                case "superadmin":
                    next = "/superadmin";
                    break;

                case "admin": {
                    const firstTab = SUBMENU.admin[0].slug;                // "echipe"
                    next = `/admin?org=${orgSlug}&tab=${firstTab}`;
                    break;
                }

                case "coach": {
                    if (!teams.length) {
                        alert("Coach fără echipe atribuite – contactează adminul.");
                        return;
                    }
                    const coachId = data.user.id;
                    const firstTab = SUBMENU.coach[0].slug;                // ex: "calendar"
                    next = `/antrenor?tab=${firstTab}`;
                    break;
                }

                case "viewer": {
                    if (!teams.length) {
                        alert("Viewer fără echipă – contactează adminul.");
                        return;
                    }
                    const firstTeamSlug = teams[0].slug;
                    next = `/${orgSlug}/${firstTeamSlug}/dashboard/players`;
                    break;
                }

                default: {                                             // alte roluri
                    const base = orgSlug !== SUPERADMIN_ORG_SLUG ? `/${orgSlug}` : "";
                    const target = LOGIN_REDIRECT[userRole] || "/";
                    next = `${base}${target}`;
                }
            }

            /* 4️⃣  Redirect efectiv */
            window.location.href = next;

        } catch (err) {
            alert(err.message);
            this.setState({ error: err.message });
        }
    };



    /* ─────────────────────────────  RENDER  ───────────────────────────── */
    render() {
        const { email, password, error, success } = this.state;

        return (
            <Card style={{ maxWidth: 400, margin: "3rem auto", padding: "2rem" }}>
                <h3>Autentificare</h3>
                <InputGroup
                    name="email"
                    placeholder="Email"
                    value={email}
                    onChange={this.handleChange}
                    style={{ marginBottom: "1rem" }}
                />
                <InputGroup
                    type="password"
                    name="password"
                    placeholder="Parolă"
                    value={password}
                    onChange={this.handleChange}
                    style={{ marginBottom: "1rem" }}
                />
                <Button intent="primary" onClick={this.handleLogin}>
                    Login
                </Button>
                {error && <p style={{ color: "red" }}>{error}</p>}
                {success && <p style={{ color: "green" }}>Login cu succes!</p>}
            </Card>
        );
    }
}

export default LoginPage;
